module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_profil.f674fef2.jpg";